// components/CustomerType.js
import React from 'react';
import styled from 'styled-components';

import { BaseLabel, RadioLabel } from '../../../styles/styleUtils';

const CustomerTypeContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  align-items: center;
`;

const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

const RadioButton = styled.input`
  margin-right: 5px;
`;


function CustomerType({ formData }) {
  return (
    <div>
      <CustomerTypeContainer>
        <BaseLabel>Tipo de Cliente</BaseLabel>
        <RadioButtonWrapper>
          <RadioButton
            type="radio"
            name="tipoCliente"
            value="F"
            checked={formData.cliente?.tipoCliente === 'F'}
            // onChange={onCustomerTypeChange}
            disabled
          />
          <RadioLabel>Pessoa Física</RadioLabel>
        </RadioButtonWrapper>
        <RadioButtonWrapper>
          <RadioButton
            type="radio"
            name="tipoCliente"
            value="J"
            checked={formData.cliente?.tipoCliente === 'J'}
            // onChange={onCustomerTypeChange}
            disabled
          />
          <RadioLabel>Pessoa Jurídica</RadioLabel>
        </RadioButtonWrapper>
      </CustomerTypeContainer>
    </div>
  );
}

export default CustomerType;
